<style lang="scss">
.search-field {
  margin-right: 100px;
}
.el-range-separator {
  width: 30% !important;
  line-height: 1.7 !important;
}
</style>
<template>
  <!-- 招新报表 -->
  <div>
    <SpFinder
      id="1"
      ref="finder"
      title="招新统计"
      :show-tool-bar="false"
      :hooks="{
        beforeSearch: beforeSearch
      }"
      :setting="setting"
      :url="{
        data: requestUrl
      }"
      :columns="columns"
      :reserve-selection="true"
      row-key="id"
      :no-selection="noSelection"
    >
      <template v-slot:dateSearch>
        <el-date-picker
          v-model="params.dateValue"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          @change="dateChange"
        />
      </template>
      <template v-slot:guide>
        <div><SpSearchStore @chooseStore="chooseStore" /></div>
      </template>
      <template v-slot:guide2>
        <div />
      </template>
      <template slot="store">
        <el-input
v-model="storeNum"
placeholder="全部门店"
disabled
>
          <div slot="append">
            <el-link
type="primary"
style="margin-right: 10px"
@click="storeVisible = true"
>
              编辑
            </el-link>
            <el-link
type="primary"
@click="clearStore"
>
重置
</el-link>
          </div>
        </el-input>
      </template>
    </SpFinder>
    <!-- 编辑门店对话框 -->
    <SpStoreSelect
      v-model="storeVisible"
      :select-data="selectStoreData"
      @chooseStore="chooseStore"
    />

    <!-- 导出列表 -->
    <SpExportList
      v-model="exportDialogVisible"
      :files-type="10"
      :show-store-select="true"
      :show-store-status="showStoreStatus"
      list-type="store"
    />
  </div>
</template>

<script>
import mixin from './mixin'
import { createSetting } from '@shopex/finder'
import moment from 'moment'
export default {
  name: 'StoreList',
  mixins: [mixin],
  data () {
    const columns = [
      {
        name: '门店编号', // 表头
        key: 'store_bn' // 匹配data key
      },
      {
        name: '员工门店', // 表头
        key: 'store_name' // 匹配data key
      },
      {
        name: '新增客户数', // 表头
        key: 'total_newuser_num' // 匹配data key
      },
      {
        name: '绑定客户数', // 表头
        key: 'total_binduser_num' // 匹配data key
      },
      {
        name: '客户删除数', // 表头
        key: 'total_userdel_num' // 匹配data key
      }
    ]
    const actions = [
      {
        name: '导出报表',
        key: 'create', // 用于指定key,必填
        slot: 'header',
        type: 'button',
        buttonType: 'primary',
        action: {
          type: 'dialog',
          title: '订单导出',
          handler: (row) => {
            this.exportDialogVisible = true
          }
        }
      }
    ]
    const search = [
      { key: 'search', name: '', slot: 'search' },
      { key: 'dateSearch', name: '', slot: 'dateSearch' },
      { key: 'store', name: '', slot: 'store' }
    ]

    return {
      setting: createSetting({
        search: [
          { key: 'dateSearch', name: '', slot: 'dateSearch' },
          { key: 'guide', name: '', slot: 'guide' },
          { key: 'guide2', name: '', slot: 'guide2' },
        ],
        actions: [
          {
            name: '导出报表',
            key: 'create', // 用于指定key,必填
            slot: 'header',
            type: 'button',
            buttonType: 'primary',
            action: {
              type: 'dialog',
              title: '订单导出',
              handler: (row) => {
                this.exportDialogVisible = true
              }
            }
          }
        ]
      }),
      requestUrl: process.env.VUE_APP_BASE_API + '/members/every-store-count',
      columns,
      actions,
      search,
      employeeInfo: [
        { value: 'store_name', label: '门店名称' },
        { value: 'store_bn', label: '门店编号' }
      ],
      storeNum: null,
      pickerOptions: {
        disabledDate (date) {
          return date.getTime() > Date.now()
        }
      },

      dialogVisible: false, //明细对话框显示与否
      detailList: [], //明细列表数据
      params: {
        keywords: '',
        dateValue: []
      },
      selectFile: 'store_name',
      listType: 'store',
      exportDialogVisible: false, //导出对话框展示与否
      storeVisible: false, //选择门店展示
      selectStoreData: [], //选择门店数据
      communityVisible: false, //选择社群展示
      selectCommunityData: [], //选择社群数据
      showStoreStatus: true,
      noSelection: true,
      showSalesPersonStatus: true,
      showGuidePicker: false,
      callData: {
        storeList: [],
        userList: []
      }
    }
  },
  computed: {
    // showDate () {
    //   let showDate = this.params.date.split('-')[1]
    //   showDate = +showDate <= 9 ? +showDate : +showDate
    //   return showDate
    // }
  },
  mounted () {},
  methods: {
    beforeSearch (params) {
      params[this.selectFile] = this.params.keywords
      params['store_id'] = this.params.store_id
      params['start_date'] = this.params.start_date
      params['end_date'] = this.params.end_date
      return params
    },
    onFinderReset () {
      this.selectStoreData = []
      this.selectFile = 'store_name'
      this.storeNum = ''
      this.params = {}
    },
    handleShowGuidePicker () {
      this.showGuidePicker = true
    },
    // 选择门店
    chooseStore (store_bn, store_id) {
      this.params.store_id = store_id
    }
  }
}
</script>
